import Routing from '../routing'

export default function Layout() {
    return(
        <Routing />
    )
}